// extracted by mini-css-extract-plugin
export default {"container":"Panel_container__MJU4h","headerContainer":"Panel_headerContainer__lb6CF","headerTextContainer":"Panel_headerTextContainer__6s2Tw"};